import { defined, Color } from "cesium";

const originalStylesMS = new WeakMap();
export const createMultiSelectHandler = (viewer, dataSource, selectedEntitiesRef, setHasSelection) => {
  const handleClick = (e) => {
    // check Ctrl (Windows) or Cmd (Mac)
    const multiKey = e.ctrlKey || e.metaKey;

    const canvasBounds = viewer.canvas.getBoundingClientRect();
    const position = {
      x: e.clientX - canvasBounds.left,
      y: e.clientY - canvasBounds.top,
    };

    const picked = viewer.scene.pick(position);

    if (!multiKey) {
      clearSelection();
      return;
    }

    if (!defined(picked) || !picked.id) return;

    const entity = picked.id;

    if (dataSource && !dataSource.entities.contains(entity)) return;

    if (selectedEntitiesRef.current.includes(entity)) {
      deselectEntity(entity);
      selectedEntitiesRef.current = selectedEntitiesRef.current.filter((ent) => ent !== entity);
      setHasSelection(selectedEntitiesRef.current.length > 0);
    } else {
      selectedEntitiesRef.current.push(entity);
      setHasSelection(true);

      if (!originalStylesMS.has(entity)) {
        originalStylesMS.set(entity, {
          material: entity.polyline?.material || entity.polygon?.material,
          width: entity.polyline?.width,
        });
      }

      if (entity.polyline) {
        entity.polyline.material = Color.RED;
      }
      if (entity.polygon) {
        entity.polygon.material = Color.RED.withAlpha(0.4);
        entity.polygon.outline = true;
        entity.polygon.outlineColor = Color.RED;
      }
    }
  };

  const deselectEntity = (entity) => {
    const original = originalStylesMS.get(entity);
    if (original) {
      if (entity.polyline) {
        entity.polyline.material = original.material;
        entity.polyline.width = original.width;
      }
      if (entity.polygon) {
        entity.polygon.material = original.material;
        entity.polygon.outline = true;
        entity.polygon.outlineColor = Color.BLACK;
      }
    }
  };

  const clearSelection = () => {
    for (const entity of selectedEntitiesRef.current) {
      deselectEntity(entity);
    }
    selectedEntitiesRef.current.length = 0;
    setHasSelection(false);
  };

  viewer.canvas.addEventListener("click", handleClick);

  return {
    destroy: () => viewer.canvas.removeEventListener("click", handleClick),
    getSelected: () => [...selectedEntitiesRef.current],
    clearSelected: clearSelection,
  };
};

export function resetEntityStyle(entity) {
  const original = originalStylesMS.get(entity);
  if (!original) return;

  if (entity.polyline) {
    entity.polyline.material = original.material;
    entity.polyline.width = original.width;
  }
  if (entity.polygon) {
    entity.polygon.material = original.material;
    entity.polygon.outline = true;
    entity.polygon.outlineColor = Color.BLACK;
  }
}
